(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nuzzlebub-crayon-offers"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nb-crayon-bundles]').forEach((wrap)=>{
 if(wrap.dataset.ready) return; wrap.dataset.ready='1';
 const cards=[...wrap.querySelectorAll('.nb-bundle-card')];
 cards.forEach(card=>card.addEventListener('click',()=>{
   cards.forEach(x=>x.classList.remove('is-selected')); card.classList.add('is-selected');
   const radio=card.querySelector('input'); radio.checked=true;
   const scope=wrap.closest('product-information')||document;
   const qty=scope.querySelector('input[name="quantity"]');
   if(qty){qty.value=radio.value;qty.dispatchEvent(new Event('change',{bubbles:true}));}
 }));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nuzzlebub-crayon-top"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-nbc-top]').forEach((wrap)=>{
 if(wrap.dataset.ready) return; wrap.dataset.ready='1';
 const scope=wrap.closest('product-information')||document;
 const setQty=(value)=>{
   const form=scope.querySelector('form[action*="/cart/add"]');
   if(form){
     let qty=form.querySelector('input[name="quantity"]');
     if(!qty){qty=document.createElement('input');qty.type='hidden';qty.name='quantity';form.appendChild(qty);}
     qty.value=value;
   }
   const checkoutLink=document.querySelector('sticky-add-to-cart [data-nbc-checkout-link]');
   if(checkoutLink && checkoutLink.dataset.variantId){
     const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
     checkoutLink.href=root+'cart/'+checkoutLink.dataset.variantId+':'+value;
   }
 };
 const cards=[...wrap.querySelectorAll('.nbc-bundle')];
 const selectBundle=(card)=>{
   cards.forEach(x=>x.classList.remove('is-selected')); card.classList.add('is-selected');
   const radio=card.querySelector('input'); radio.checked=true; setQty(radio.value);
 };
 cards.forEach(card=>card.addEventListener('click',()=>selectBundle(card)));
 wrap.querySelectorAll('[data-remove-bundle]').forEach(remove=>{
   const reduce=(e)=>{
     e.preventDefault(); e.stopPropagation();
     const current=remove.closest('.nbc-bundle');
     const qty=parseInt(current.querySelector('input').value,10);
     const target=cards.find(x=>parseInt(x.querySelector('input').value,10)===Math.max(1,qty-1));
     if(target) selectBundle(target);
   };
   remove.addEventListener('click',reduce);
   remove.addEventListener('keydown',(e)=>{if(e.key==='Enter'||e.key===' '){reduce(e);}});
 });
 setTimeout(()=>setQty((wrap.querySelector('input:checked')||{}).value||'1'),150);
 const countdown=wrap.querySelector('[data-nbc-countdown]');
 if(countdown){
   const end=new Date('2026-10-31T23:59:59+11:00').getTime();
   const tick=()=>{
     const left=end-Date.now();
     if(left<=0){countdown.textContent='Sale ended';return false;}
     const d=Math.floor(left/86400000);
     const h=Math.floor((left%86400000)/3600000);
     const m=Math.floor((left%3600000)/60000);
     const s=Math.floor((left%60000)/1000);
     countdown.textContent=d+'d '+h+'h '+m+'m '+s+'s';
     return true;
   };
   if(tick()){const timer=setInterval(()=>{if(!tick())clearInterval(timer)},1000);}
 }
});
  } catch(e) { console.error(e); }
})();

})();
